import { render, staticRenderFns } from "./ZlmxEdit.vue?vue&type=template&id=20043c07"
import script from "./ZlmxEdit.vue?vue&type=script&lang=js"
export * from "./ZlmxEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports